<template>
  <div class="grid grid-cols-1 gap-6 sm:gap-8 md:grid-cols-2 lg:gap-10">
    <div v-for="product in products" :key="product.id" class="relative bg-white rounded-2xl shadow-md p-6">
      <h3 class="text-lg sm:text-xl font-semibold text-gray-800 leading-tight sm:leading-7 mb-4 sm:mb-6">
        {{ product.title }}
      </h3>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2">
        <div class="space-y-2">
          <StackedField v-if="product.itemType" :label="t('category')" :value="$t(product.itemType)" />
          <StackedField :label="t('vendor')" :value="product.vendor" />
          <StackedField v-if="product.model" :label="t('model')" :value="product.model" />
          <StackedField :label="t('price')" :value="formatPrice(product.price)" />
        </div>
        <div class="space-y-2">
          <StackedField v-if="product.referenceId" :label="t('reference_id')" :value="product.referenceId" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { StackedField, formatPrice } from "@estaly/ui";
import { useI18n } from "vue-i18n";

export default {
  name: "InsuredProductsInformations",

  components: { StackedField },

  props: {
    products: {
      type: Array,
      required: true,
      default: () => [],
    },
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  methods: { formatPrice },
};
</script>

<i18n src="./InsuredProductsInformations.i18n.json"></i18n>
